<mat-card appearance="outlined">
	<mat-card-title [innerText]="'MAIN_APP_DIALOG.APPOINTMENT_DETAILS.title' | translate"></mat-card-title>
	<mat-card-content>
		<span class="title">{{ data.Subject }} | {{ getTimeString(data.StartTime) }} - {{ getTimeString(data.EndTime) }}</span>
		<span *ngIf="data.projectLeader">{{ "MAIN_APP_TIME.SHARE_ORDER.projectLeader" | translate }}: {{ data.projectLeader }} </span>
		<span *ngIf="data.Location">{{ data.Location }}</span>
		<span *ngIf="data.Name"> | {{ data.Name }} </span>
		<span *ngIf="data.Phone"> | {{ data.Phone }} </span>
		<span *ngIf="data.AnspPhone"> | {{ data.AnspPhone }} </span>
		<span *ngIf="data.Category">{{ data.Category.description }}</span>
		<span *ngIf="data.Notes" [innerText]="data.Notes" style="word-break: break-word; font-weight: bold"></span>
	</mat-card-content>
	<mat-dialog-actions>
		<button (click)="closeDialog()" [innerText]="'MAIN_APP_DIALOG.close' | translate" class="cancel" mat-stroked-button></button>
	</mat-dialog-actions>
</mat-card>
